/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_interactions_init = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	/**
	None yet
	**/

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');

		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Catch and active URL
		*/
		specific_interactions.catchAndActiveURL();

		/*
		Specific: Color Mode and Logo
		*/
		specific_colormode.onready();
		specific_logo.onready();

		/**
		 * Tijd voor creativiteit
		 */
		document.querySelectorAll('.cta h2').forEach(function(h2) {
			const text = h2.textContent;
			h2.innerHTML = '';
			text.split('').forEach(function(letter, i) {
				const span = document.createElement('span');
				span.textContent = letter === ' ' ? '\u00A0' : letter; // NBSP voor spaties
				span.style.setProperty('--i', i);
				h2.appendChild(span);
			});
		});

		/*
		Swiper
		*/
		if (
			url[2] == ''
		) {
			var _spotlight_swiper = new Swiper('.swiper', {

				loop: true,

				// autoplay: {
				// 	delay: 3000,
				// 	disableOnInteraction: false,
				// },

				loopPreventsSliding: false,

				pagination: {
					el: '.swiper-pagination',
				},

				navigation: {
					nextEl: '.js-swiper-button-next-alt',
					prevEl: '.js-swiper-button-prev-alt',
				},

			});
		}

		// Showcase: Scroller
		if (
			url[2] == 'showcase'
		) {

			specific_showcase.onready();

			/*
			Header: Showcase mode
			*/
			$('header').addClass('showcase-mode');
			// $('.js-slogan').stop().fadeOut(500);

			/*
			Footer hide
			*/
			$('footer').hide();

		} else {

			/*
			Header: Showcase mode
			*/
			$('header').removeClass('showcase-mode');
			// $('.js-slogan').stop().fadeIn(500);

			/*
			Footer show
			*/
			$('footer').show();

		}

		/*
		Video observer
		*/
		document.querySelectorAll('video[data-src]').forEach(function(video) {
			if (!video.dataset.observed) {
				_videoObserver.observe(video);
				video.dataset.observed = "true";
			}
		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init); 
